import * as yup from "yup";
import { nameValidator } from "./commonValidators";
import { templateLimitValueValidator } from "./licenseLimitValidators";

export const validateInformation = yup.object({
  name: nameValidator,
  description: yup.string(),
});

export const validateLimits = (data) =>
  yup.object({
    limits: yup.object(
      Object.keys(data).reduce(
        (accum, key) => ({
          ...accum,
          [key]: templateLimitValueValidator,
        }),
        {},
      ),
    ),
  });
